import React, { useState, useContext, useEffect, useRef } from "react";
import { FieldArray, Formik, Field } from "formik";
import { Form, Card, Button } from "react-bootstrap";
import "../../../styles/containers/MapperLoadDefinitionFilter.scss";
import * as Yup from "yup";
import {
  FieldButtonGroup,
  FieldDropSide,
  DatePicker,
  SearchableList,
  FieldInput,
  ManageMapperLayout,
  LoaderWrapper,
  WarningModal,
  AddToolTip,
  FormLeaveGuard,
} from "../../../components";
import { isEmpty, get, head } from "lodash";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  MANAGE_MAPPER_POST_API_ERROR,
  setMapperPostResponse,
  setFileUploadData,
} from "../../../contexts";
import {
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  usDateFormat,
  FLOW_TYPES,
  ROUTES,
  splitParams,
  filterExpressionConverter,
  CensusFilterData,
  PayrollFilterData,
  CensusAndPayrollFilterData,
  yesNoOptions,
  extraFilterFields,
  required,
  getPathWithParam,
} from "../../../utils";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { onOutputFilterSave, onPassthroughFilterSave } from "../../../services";
import FilterSourceForOutput from "./FilterSourceForOutput";
import moment from "moment/moment";

const MapperOutputFilterContainer = (props) => {
  const fieldvalidations = {
    From: {
      SimoptValues: ["", undefined],
      DataTypeValues: [4],
    },
    To: {
      SimoptValues: ["", undefined],
      DataTypeValues: [4],
    },
    selectedFilter: {
      SimoptValues: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      DataTypeValues: [1, 2, 4],
    },
  };
  const { state, dispatch } = useContext(manageMapperStore);
  const { history } = props;
  const { flow, profileId, mapType } = useRouterParams();
  const data = get(state, "api.data", []);
  const fileName = get(state, "api.data.fileName", []);
  const [modalVisible, setModalVisible] = useState(false);
  var fileFormat = get(state, "api.data.format");
  var fileFormatExtenstion = fileFormat === 1 ? ".csv" : ".xlsx";
  const [applyFilter, setApplyFilter] = useState(false);
  const isFilterApplied = get(data, "isFilterApplied", false);
  const [dataLoading, setDataLoading] = useState(false);
  const dataModel = get(state, "api.data.dataModel", "");
  const headersJson = get(state, "api.data.headerMapJson");
  const fileUpload = get(state, "api.fileuploadData", []);
  const fileuploadData = JSON.stringify(get(fileUpload, "row"));
  const [header, setHeader] = useState([]);
  const fileUploadFields = !isEmpty(fileuploadData)
    ? fileuploadData
    : get(fileUpload, "mappingConfiguration.headerMapJson", "");

  const fieldHeadersJson = isEmpty(fileUpload) ? headersJson : fileUploadFields;

  const model = [
    ...(dataModel === 2
      ? CensusFilterData
      : dataModel === 1
      ? PayrollFilterData
      : CensusAndPayrollFilterData),
    ...extraFilterFields,
  ];
  const [filterConditionFields, setfilterConditionFields] = useState(model);
  const [searchFilter, setSearchFilter] = useState(filterConditionFields);
  useDeepEffect(() => {
    try {
      const parseField = headersJson ?? fieldHeadersJson;
      if (!isEmpty(parseField)) {
        const parsedHeadersJson = JSON.parse(parseField);
        let list = parsedHeadersJson?.map((val, ind) => {
          return {
            selected: false,
            displayName: val.propertyName,
            propertyName: val.propertyName,
            dataType: val.type,
            datum: val.datum,
            options:
              val.type == 1
                ? [
                    [
                      "Is Not Null",
                      "Is Null",
                      "Is equal to",
                      "Contains",
                      "Starts With",
                      "Ends With",
                      "Length Equal to",
                      "Length Greater than",
                      "Length Lesser than",
                      "Length Greater than or equal to",
                      "Length Lesser than or equal to",
                    ],
                  ]
                : val.type == 2
                ? [
                    [
                      "Is Not Null",
                      "Is Null",
                      "Between",
                      "Is equal to",
                      "Contains",
                      "Starts With",
                      "Ends With",
                      "Length Equal to",
                      "Length Greater than",
                      "Length Lesser than",
                      "Length Greater than or equal to",
                      "Length Lesser than or equal to",
                      "Greater than",
                      "Lesser than",
                      "Greater than or equal to",
                      "Lesser than or equal to",
                    ],
                  ]
                : val.type == 4
                ? [
                    [
                      "Is Not Null",
                      "Is Null",
                      "Between",
                      "Is equal to",
                      "Greater than",
                      "Lesser than",
                      "Greater than or equal to",
                      "Lesser than or equal to",
                    ],
                  ]
                : [[]],
            selectedFilter: "",
            SimOpt: "",
            From: "",
            To: "",
            isCollection: false,
          };
        });
        setHeader(list);
        setfilterConditionFields(list);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }, [fieldHeadersJson]);

  const isEdit = flow === FLOW_TYPES.EDIT;
  let filteredArray;
  let i = 0;
  const [controlVar, setControlVar] = useState(true);
  const ref1 = useRef(null);
  const filterObjectJson =
    !isEmpty(get(data, "filterObjectJson", {})) &&
    JSON.parse(get(data, "filterObjectJson", {}));

  const navigateToMapperHomePage = () => {
    history.push(
      getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      })
    );
  };

  const getoptionForFilter = (functionName, dataType) => {
    if (dataType == 1) {
      switch (functionName) {
        case "IsNotNullOrEmpty":
          return 0;
        case "IsNullOrEmpty":
          return 1;
        case "Equal":
          return 2;
        case "Contains":
          return 3;
        case "StartsWith":
          return 4;
        case "EndsWith":
          return 5;
        case "LengthEqualTo":
          return 6;
        case "LengthGreaterThan":
          return 7;
        case "LengthLesserThan":
          return 8;
        case "LengthGreaterThanOrEqualTo":
          return 9;
        case "LengthLesserThanOrEqualTo":
          return 10;
      }
    } else if (dataType == 2) {
      switch (functionName) {
        case "IsNotNullOrEmpty":
          return 0;
        case "IsNullOrEmpty":
          return 1;
        case "Between":
          return 2;
        case "Equal":
          return 3;
        case "Contains":
          return 4;
        case "StartsWith":
          return 5;
        case "EndsWith":
          return 6;
        case "LengthEqualTo":
          return 7;
        case "LengthGreaterThan":
          return 8;
        case "LengthLesserThan":
          return 9;
        case "LengthGreaterThanOrEqualTo":
          return 10;
        case "LengthLesserThanOrEqualTo":
          return 11;
        case "GreaterThan":
          return 12;
        case "LessThan":
          return 13;
        case "GreaterThanOrEqual":
          return 14;
        case "LessThanOrEqual":
          return 15;
      }
    } else if (dataType == 4) {
      switch (functionName) {
        case "IsNotNullOrEmpty":
          return 0;
        case "IsNullOrEmpty":
          return 1;
        case "Between":
          return 2;
        case "Equal":
          return 3;
        case "GreaterThan":
          return 4;
        case "LessThan":
          return 5;
        case "GreaterThanOrEqual":
          return 6;
        case "LessThanOrEqual":
          return 7;
      }
    }
  };

  useDeepEffect(() => {
    if (!isEmpty(filterObjectJson)) {
      let fieldsData = mapType == 3 ? header : filterConditionFields;
      if (!isEmpty(fieldsData)) {
        setfilterConditionFields(
          fieldsData?.map((ele, ind) => {
            var selectedOption = false;
            var option = 1;
            var initial, final, res;
            var foundObject = filterObjectJson.find(
              (_) => _.fieldName == ele.propertyName
            );
            var foundDataType;
            if (
              filterObjectJson?.map((x, id) => {
                if (x.fieldName == ele.propertyName) {
                  foundDataType = ele.dataType;
                }
              })
            )
              var [firstKey] = Object.keys(filterObjectJson);
            const firstKeyFieldName = filterObjectJson[firstKey].fieldName;

            if (!isEmpty(foundObject)) {
              selectedOption = true;
              // var complexFunctionName = foundObject?.expression.replace(
              //   /[(]/g,
              //   ""
              // );
              var exp = foundObject?.expression;
              var parameters = splitParams(
                exp?.substring(exp?.indexOf("(") + 1, exp?.lastIndexOf(")"))
              );
              var res = parameters[1];
              var resFrom = parameters[1];
              var resTo = parameters[2];
              var finalFunction = exp?.substring(0, exp?.indexOf("(") || 0);
              option = getoptionForFilter(finalFunction, foundDataType);
            }

            return {
              ...ele,
              selected: selectedOption,
              SimOpt: option,
              filterSelect: firstKeyFieldName == ele.propertyName && true,
              selectedFilter: res?.slice(1, -1),
              From: resFrom?.slice(1, -1),
              To: resTo?.slice(1, -1),
            };
          })
        );
      }
    }
  }, [filterObjectJson, header]);

  useEffect(() => {
    !isEmpty(filterConditionFields) &&
      filterConditionFields.map((item) => {
        if (i == 0 && controlVar && item.selected) {
          i = i + 1;
          setControlVar(false);
          // setSelopt(item.id);
        }
      });
  }, []);

  useEffect(() => {
    if (!isEmpty(get(state, formName, []))) {
      setApplyFilter(get(state, formName, []).isFilterApplied);
    } else {
      setApplyFilter(isFilterApplied);
    }
  }, [isFilterApplied]);

  const toOptionValuesFromMapper = (obj) => {
    return Object.keys(obj).map((key, index) => ({
      label: obj[key],
      value: index,
      // value: !isNaN(key) ? parseInt(key, 10) : key,
    }));
  };

  const formName = manageMapperFormNames.OUTPUT_FILTER;
  const [errorList, setErrorList] = useState({});
  const filterApiCall = (payload) => {
    if (mapType != 3) {
      return onOutputFilterSave(payload);
    } else {
      return onPassthroughFilterSave(payload);
    }
  };
  // const ValidationSchema = Yup.object().shape({
  //   SimOpt: Yup.array().string()
  //     .required("Required")
  // });
  const onFormSubmit = (values, { setFieldError, errors }) => {
    var findIndexOfFilterCondition = filterConditionFields.findIndex(
      (a) =>
        (a.SimOpt === undefined || a.SimOpt === "") &&
        a.selected &&
        !a.filterSelect
    );
    if (
      filterConditionFields.find(
        (_) =>
          _.filterSelect == false &&
          (_.SimOpt === undefined || _.SimOpt === "") &&
          _.selected
      )
    ) {
      setfilterConditionFields(
        filterConditionFields.map((val, ind) => {
          return {
            ...val,
            filterSelect: ind == findIndexOfFilterCondition ? true : false,
          };
        })
      );
    } else {
      setErrorList({});
      let tempErrorList = {};
      setfilterConditionFields(
        filterConditionFields.map((obj, ind) => {
          if (obj.selected) {
            if (
              obj.SimOpt === null ||
              obj.SimOpt === undefined ||
              obj.SimOpt === ""
            ) {
              const filterSelected = isEmpty(tempErrorList);
              tempErrorList = {
                ...tempErrorList,
                [ind]: { SimOpt: "required" },
              };
              return { ...obj, filterSelect: filterSelected };
            } else {
              for (let i in Object.keys(fieldvalidations)) {
                let key_ = Object.keys(fieldvalidations)[i];
                if (
                  !fieldvalidations[key_].SimoptValues.includes(obj.SimOpt) &&
                  !fieldvalidations[key_].DataTypeValues.includes(
                    obj.dataType
                  ) &&
                  !obj[key_]
                ) {
                  const filterSelected = isEmpty(tempErrorList);
                  // tempErrorList = {
                  //   ...tempErrorList,
                  //   [ind]: { ...get(tempErrorList, ind, {}), [key_]: "required" },
                  // };
                  return { ...obj, filterSelect: filterSelected };
                }
              }
            }
          }
          return { ...obj, filterSelect: false };
        })
      );
      setErrorList(tempErrorList);
      if (isEmpty(tempErrorList)) {
        setDataLoading(true);
        let filterOption = filterConditionFields.filter((itm) => itm.selected);
        let saveData =
          filterOption &&
          filterOption.map((_) => {
            return {
              fieldName: _.propertyName,
              expression: filterExpressionConverter(_),
            };
          });
        onOutputFilterSave({
          ...data,
          isFilterApplied: applyFilter,
          filterObjectJson: JSON.stringify(applyFilter ? saveData : []),
          //filterObjectJson : statemodel.map(itm => {return {fieldName:itm.fieldName,expression:filterExpressionConverter(itm)}}),
        })
          .then((res) => {
            if (!isEmpty(res)) {
              setDataLoading(false);
              dispatch(setMapperPostResponse(res));
              dispatch(
                setManageMapperToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
              isEdit
                ? history.push(`${ROUTES.MAPPER_HOME}`)
                : history.push(
                    `${MANAGE_MAPPER_ROUTES.REVIEW_AND_CONFIRM}/${mapType}/${profileId}`
                  );
            } else {
              dispatch({
                type: MANAGE_MAPPER_POST_API_ERROR,
                payload: "Something went wrong! please try again.",
              });
              setDataLoading(false);
            }
          })
          .catch((err) => {
            setDataLoading(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          });
      }
    }
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];

  return (
    <Formik
      initialValues={filterConditionFields}
      initialErrors={errorList}
      onSubmit={onFormSubmit}
      // validationSchema={ValidationSchema}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      innerRef={ref1}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          validateOnChange,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          dirty,
          touched,
          errors,
          ...rest
        } = formProps;
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const onInputChange = (index, parentIndex, fieldName, value) => {
          setfilterConditionFields(
            filterConditionFields.map((val, ind) => {
              if (ind === index && parentIndex === undefined) {
                return {
                  ...val,
                  [fieldName]: value,
                };
              } else if (ind === parentIndex) {
                return {
                  ...val,
                  childObjectMaps: val.childObjectMaps.map((_, i) => {
                    return i === index
                      ? {
                          ..._,
                          [fieldName]: value,
                        }
                      : _;
                  }),
                };
              }
              return val;
            })
          );
        };

        const SelectionComponent = ({ ele, index, parentIndex }) => {
          return (
            <Card
              className={
                ele.filterSelect == true
                  ? "FTargetCard-selected"
                  : "FTargetCard-normal"
              }
              style={{ width: "100%" }}
              id={ele.id}
              onClick={() => {
                setfilterConditionFields(
                  filterConditionFields.map((val, ind) => {
                    return {
                      ...val,
                      filterSelect: index == ind ? true : false,
                    };
                  })
                );
              }}
            >
              <div className="FTitle">
                <AddToolTip name={ele.displayName} />
              </div>
            </Card>
          );
        };
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <ManageMapperLayout buttons={buttons} layoutHeader="Filter">
              <LoaderWrapper isLoading={dataLoading}>
                <FormLeaveGuard
                  showModal={modalVisible}
                  handleConfirmClick={() => navigateToMapperHomePage()}
                  handleCancelClick={() => setModalVisible(false)}
                />

                <div>
                  <div
                    style={{
                      display: "block",
                      // font: "Poppins",
                      fontSize: "18px",
                      fontWeight: "500",
                      alignItems: "center",
                      paddingBottom: "0",
                    }}
                  >
                    <div
                      style={{
                        paddingBottom: "0.5rem",
                        color: "#494F5A",
                        fontSize: "18px",
                        fontWeight: "550",
                      }}
                    >
                      Apply filter
                    </div>
                    <div style={{ display: "flex" }}>
                      <Field
                        isRequired
                        name="applyfilter"
                        size="md"
                        className="bg-transparent p-0"
                        options={yesNoOptions}
                        selectedValue={applyFilter}
                        onChange={(value) => {
                          setApplyFilter(value);
                        }}
                        component={FieldButtonGroup}
                      />
                    </div>
                  </div>
                </div>
                {applyFilter && !isEmpty(filterConditionFields) ? (
                  <div style={{ display: "flex" }}>
                    <FilterSourceForOutput
                      mapType={mapType}
                      searchFilter={searchFilter}
                      setSearchFilter={setSearchFilter}
                      filteredArray={filteredArray}
                      fileFormatExtenstion={fileFormatExtenstion}
                      fileName={fileName}
                      fields={filterConditionFields}
                      filterObjectJson={filterObjectJson}
                      setfields={setfilterConditionFields}
                    />
                    <div className="FilterConditionContainer">
                      <div className="FilterConditionTitleText">
                        Selected filter condition
                      </div>
                      <div>
                        <FieldArray name="info">
                          {() => (
                            <div
                              style={{
                                border: "1px solid #E5E5E5",
                                borderRadius: "5px",
                                // border: "2px solid yellow",
                                width: "42rem",
                                height: "28rem",
                                display: "flex",
                              }}
                            >
                              <div className="FilterList">
                                {filterConditionFields?.map((ele, index) => {
                                  if (!ele.isCollection && ele.selected) {
                                    return (
                                      <SelectionComponent
                                        ele={ele}
                                        index={index}
                                      />
                                    );
                                  } else {
                                    return (
                                      <>
                                        {ele.childObjectMaps?.map(
                                          (value, ind) => {
                                            if (value.selected) {
                                              return (
                                                <>
                                                  <SelectionComponent
                                                    ele={value}
                                                    index={ind}
                                                    parentIndex={index}
                                                  />
                                                </>
                                              );
                                            }
                                          }
                                        )}
                                      </>
                                    );
                                  }
                                })}
                              </div>
                              <div className="OptionContainer">
                                {filterConditionFields.map((item, index) => {
                                  return item.selected ? (
                                    <>
                                      {item.filterSelect && (
                                        <>
                                          <div className="OptTitle">
                                            Filter Options
                                          </div>
                                          <div className="ConTitle">
                                            Condition
                                          </div>
                                          <div
                                            key={item.id}
                                            style={{
                                              width: "20rem",
                                              fontSize: "14px",
                                              // font: "Poppins",
                                              fontWeight: "400",
                                              paddingBottom: "1rem",
                                            }}
                                          >
                                            <div className="dropdown-alignment">
                                              <Field
                                                name={`${index}.SimOpt`}
                                                value={values[index]["SimOpt"]}
                                                options={toOptionValuesFromMapper(
                                                  item.options[0]
                                                )}
                                                isRequired
                                                validate={required}
                                                direction={"bottom"}
                                                popupContent={
                                                  <SearchableList
                                                    label="Select filter"
                                                    isNotTypeAhead
                                                    options={toOptionValuesFromMapper(
                                                      item.options[0]
                                                    )}
                                                    onSelect={(value) => {
                                                      setfilterConditionFields(
                                                        filterConditionFields?.map(
                                                          (val, ind) => {
                                                            return ind == index
                                                              ? {
                                                                  ...val,
                                                                  SimOpt: value,
                                                                }
                                                              : val;
                                                          }
                                                        )
                                                      );
                                                    }}
                                                    selectedValue={item.SimOpt}
                                                  />
                                                }
                                                component={FieldDropSide}
                                              />
                                            </div>
                                            {item.SimOpt == 2 &&
                                              item.dataType === 1 && (
                                                <div>
                                                  <Field
                                                    name={`${index}.selectedFilter`}
                                                    label={"Input"}
                                                    value={item.selectedFilter}
                                                    validate={required}
                                                    component={FieldInput}
                                                    isRequired
                                                    onChange={(event) =>
                                                      setfilterConditionFields(
                                                        filterConditionFields.map(
                                                          (val, ind) => {
                                                            return ind == index
                                                              ? {
                                                                  ...val,
                                                                  selectedFilter:
                                                                    event.target
                                                                      .value,
                                                                }
                                                              : val;
                                                          }
                                                        )
                                                      )
                                                    }
                                                  />
                                                </div>
                                              )}

                                            {item.SimOpt == 2 &&
                                              item.dataType === 2 && (
                                                <div>
                                                  {
                                                    <Field
                                                      label={"From"}
                                                      name={`${index}.From`}
                                                      values={item.From}
                                                      validate={required}
                                                      component={FieldInput}
                                                      onChange={(event) =>
                                                        setfilterConditionFields(
                                                          filterConditionFields.map(
                                                            (val, ind) => {
                                                              return ind ==
                                                                index
                                                                ? {
                                                                    ...val,
                                                                    From:
                                                                      event
                                                                        .target
                                                                        .value,
                                                                  }
                                                                : val;
                                                            }
                                                          )
                                                        )
                                                      }
                                                      isRequired
                                                      selectedValue={item.From}
                                                    />
                                                  }
                                                  {
                                                    <Field
                                                      label={"To"}
                                                      name={`${index}.To`}
                                                      values={item.To}
                                                      component={FieldInput}
                                                      validate={required}
                                                      onChange={(event) =>
                                                        setfilterConditionFields(
                                                          filterConditionFields.map(
                                                            (val, ind) => {
                                                              return ind ==
                                                                index
                                                                ? {
                                                                    ...val,
                                                                    To:
                                                                      event
                                                                        .target
                                                                        .value,
                                                                  }
                                                                : val;
                                                            }
                                                          )
                                                        )
                                                      }
                                                      isRequired
                                                    />
                                                  }
                                                </div>
                                              )}

                                            {!(
                                              item.SimOpt == 0 ||
                                              item.SimOpt == 1 ||
                                              item.SimOpt == ""
                                            ) ? (
                                              !(item.dataType === 4) ? (
                                                !(item.SimOpt == 2) ? (
                                                  <div>
                                                    <Field
                                                      name={`${index}.selectedFilter`}
                                                      label={"Input"}
                                                      value={
                                                        item.selectedFilter
                                                      }
                                                      component={FieldInput}
                                                      validate={required}
                                                      isRequired
                                                      onChange={(event) =>
                                                        setfilterConditionFields(
                                                          filterConditionFields.map(
                                                            (val, ind) => {
                                                              return ind ==
                                                                index
                                                                ? {
                                                                    ...val,
                                                                    selectedFilter:
                                                                      event
                                                                        .target
                                                                        .value,
                                                                  }
                                                                : val;
                                                            }
                                                          )
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                ) : (
                                                  <div>
                                                    {/* <Field
                                                      label={"From132"}
                                                      name={`${index}.From`}
                                                      values={item.From}
                                                      component={FieldInput}
                                                      onChange={(event) =>
                                                        setfilterConditionFields(
                                                          filterConditionFields.map(
                                                            (val, ind) => {
                                                              return ind ==
                                                                index
                                                                ? {
                                                                    ...val,
                                                                    From:
                                                                      event
                                                                        .target
                                                                        .value,
                                                                  }
                                                                : val;
                                                            }
                                                          )
                                                        )
                                                      }
                                                      isRequired
                                                      selectedValue={item.From}
                                                    /> */}
                                                    {/* <Field
                                                      label={"To"}
                                                      name={`${index}.To`}
                                                      values={item.To}
                                                      component={FieldInput}
                                                      onChange={(event) =>
                                                        setfilterConditionFields(
                                                          filterConditionFields.map(
                                                            (val, ind) => {
                                                              return ind ==
                                                                index
                                                                ? {
                                                                    ...val,
                                                                    To:
                                                                      event
                                                                        .target
                                                                        .value,
                                                                  }
                                                                : val;
                                                            }
                                                          )
                                                        )
                                                      }
                                                      isRequired
                                                    /> */}
                                                  </div>
                                                )
                                              ) : !(
                                                  values[index]["SimOpt"] == 2
                                                ) ? (
                                                <div>
                                                  <Field
                                                    name={`${index}.selectedFilter`}
                                                    label={"Select date"}
                                                    validate={required}
                                                    isRequired
                                                    size="sm"
                                                    value={
                                                      item?.selectedFilter
                                                        ? moment(
                                                            item?.selectedFilter
                                                          )?.format(
                                                            "MM/DD/YYYY"
                                                          )
                                                        : ""
                                                    }
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.selectedFilter`,
                                                        ""
                                                      );
                                                      item.selectedFilter = "";
                                                    }}
                                                    isDatePicker
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          value = moment(
                                                            new Date(value)
                                                          )?.format(
                                                            "M/D/YYYY 12:00:00 A"
                                                          );
                                                          onDaySelected(
                                                            `${index}.selectedFilter`,
                                                            value
                                                          );
                                                          item.selectedFilter = value;
                                                          let newfields = [
                                                            ...filterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "selectedFilter"
                                                          ] = value;
                                                          setfilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={
                                                          item?.selectedFilter
                                                            ? new Date(
                                                                item?.selectedFilter
                                                              )
                                                            : new Date()
                                                        }
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                </div>
                                              ) : (
                                                <div>
                                                  <Field
                                                    label={"From"}
                                                    name={`${index}.From`}
                                                    validate={required}
                                                    isRequired
                                                    direction="rightSide"
                                                    size="sm"
                                                    value={
                                                      item?.From
                                                        ? moment(
                                                            item?.From
                                                          )?.format(
                                                            "MM/DD/YYYY"
                                                          )
                                                        : ""
                                                    }
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.From`,
                                                        ""
                                                      );
                                                      item.From = "";
                                                    }}
                                                    isDatePicker
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          value = moment(
                                                            new Date(value)
                                                          ).format(
                                                            "M/D/YYYY 12:00:00 A"
                                                          );
                                                          onDaySelected(
                                                            `${index}.From`,
                                                            value
                                                          );
                                                          item.From = value;
                                                          let newfields = [
                                                            ...filterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "From"
                                                          ] = value;
                                                          setfilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={
                                                          item?.From
                                                            ? new Date(
                                                                item?.From
                                                              )
                                                            : new Date()
                                                        }
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                  <Field
                                                    label={"To"}
                                                    name={`${index}.To`}
                                                    validate={required}
                                                    isRequired
                                                    size="sm"
                                                    value={
                                                      item?.To
                                                        ? moment(
                                                            item?.To
                                                          )?.format(
                                                            "MM/DD/YYYY"
                                                          )
                                                        : ""
                                                    }
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.To`,
                                                        ""
                                                      );
                                                      item.To = "";
                                                    }}
                                                    isDatePicker
                                                    direction="rightSide"
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          value = moment(
                                                            new Date(value)
                                                          ).format(
                                                            "M/D/YYYY 12:00:00 A"
                                                          );
                                                          onDaySelected(
                                                            `${index}.To`,
                                                            value
                                                          );
                                                          item.To = value;
                                                          let newfields = [
                                                            ...filterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "To"
                                                          ] = value;
                                                          setfilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={
                                                          item?.To
                                                            ? new Date(item?.To)
                                                            : new Date()
                                                        }
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                </div>
                                              )
                                            ) : (
                                              <> </>
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <> </>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {values?.map((x) => (x.selected = false))}
                    <div className="FilterUnavailable"> Filter not applied</div>
                  </>
                )}
                {/* <pre>{JSON.stringify(filterConditionFields, null, 2)}</pre> */}
              </LoaderWrapper>
            </ManageMapperLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default MapperOutputFilterContainer;
